export default __webpack_public_path__ + "static/media/popup card.03a098e3.svg";